"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQueryPreservingReplacingLinkCellFormatter = exports.createQueryPreservingLinkCellFormatter = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var LinkCellFormatter_1 = require("./LinkCellFormatter");
/**
 * Preserves the query string (the part of the URL starting with ?).
 */
function createQueryPreservingLinkCellFormatter(getNameFromRowData, getPathFromRowData) {
    return function (props) { return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(QueryPreservingLinkCellFormatter, { pathname: getPathFromRowData(urls, props.row.data), name: getNameFromRowData(props.row.data) });
    })); };
}
exports.createQueryPreservingLinkCellFormatter = createQueryPreservingLinkCellFormatter;
/**
 * Same as createQueryPreservingLinkCellFormatter, except uses history.replace instead of history.push.
 */
function createQueryPreservingReplacingLinkCellFormatter(getNameFromRowData, getPathFromRowData) {
    return function (props) { return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(QueryPreservingReplacingLinkCellFormatter, { pathname: getPathFromRowData(urls, props.row.data), name: getNameFromRowData(props.row.data) });
    })); };
}
exports.createQueryPreservingReplacingLinkCellFormatter = createQueryPreservingReplacingLinkCellFormatter;
function QueryPreservingLinkCellFormatter(props) {
    return (React.createElement("div", { className: LinkCellFormatter_1.linkCellClass },
        React.createElement(react_router_dom_1.Route, { render: function (_a) {
                var location = _a.location;
                return React.createElement(react_router_dom_1.Link, { className: data_catalog_shared_1.linkClass, to: __assign(__assign({}, location), { pathname: props.pathname }), title: props.name }, props.name);
            } })));
}
var QueryPreservingReplacingLinkCellFormatter = /** @class */ (function (_super) {
    __extends(QueryPreservingReplacingLinkCellFormatter, _super);
    function QueryPreservingReplacingLinkCellFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QueryPreservingReplacingLinkCellFormatter.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_router_dom_1.Route, { render: function (_a) {
                var location = _a.location, history = _a.history;
                return React.createElement(QueryPreservingReplacingLinkCellFormatterInternal, { name: _this.props.name, pathname: _this.props.pathname, location: location, history: history });
            } }));
    };
    return QueryPreservingReplacingLinkCellFormatter;
}(React.Component));
/**
 * To implement a Link variant that uses history.replace instead of history.push,
 * all we should need to do is pass replace={true} to Link.
 * This works in the example, but fails in vizportalclient, for some poorly understood interaction
 * with other URL handling in that environment (likely related to Angular UI Router).
 * To work around this problem, we add a raw (non-React) event handler to the anchor
 * element and use it to call preventDefault on the click event.
 * This avoids whatever in vizportalclient was causing history.replace to not work.
 * We then implement a version of Link's (React) click handler that runs even when preventDefault
 * has been called, copying the relevant checks (for mouse button and modifier keys).
 * It may be possible to remove the extra complexity in the future,
 * maybe once Anugular UI Router is removed from vizportalclient.
 */
var QueryPreservingReplacingLinkCellFormatterInternal = /** @class */ (function (_super) {
    __extends(QueryPreservingReplacingLinkCellFormatterInternal, _super);
    function QueryPreservingReplacingLinkCellFormatterInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.anchorRef = null;
        _this.handleClick = function (event) {
            if (event.button === 0 && !isModifiedEvent(event)) {
                event.preventDefault();
                _this.props.history.replace(__assign(__assign({}, _this.props.location), { pathname: _this.props.pathname }));
            }
        };
        _this.setAnchorRef = function (anchorRef) {
            if (_this.anchorRef) {
                _this.anchorRef.removeEventListener('click', preventDefaultHandler);
                _this.anchorRef = null;
            }
            if (anchorRef) {
                _this.anchorRef = anchorRef;
                _this.anchorRef.addEventListener('click', preventDefaultHandler);
            }
        };
        return _this;
    }
    QueryPreservingReplacingLinkCellFormatterInternal.prototype.render = function () {
        return (React.createElement("div", { className: LinkCellFormatter_1.linkCellClass },
            React.createElement(react_router_dom_1.Link, { className: data_catalog_shared_1.linkClass, to: __assign(__assign({}, this.props.location), { pathname: this.props.pathname }), title: this.props.name, replace: true, innerRef: this.setAnchorRef, onClick: this.handleClick }, this.props.name)));
    };
    return QueryPreservingReplacingLinkCellFormatterInternal;
}(React.Component));
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function preventDefaultHandler(event) {
    event.preventDefault();
}
//# sourceMappingURL=QueryPreservingLinkCellFormatter.js.map